import axios from 'axios';
import {
  TBodyGiftPredict,
  TBodyGiftRequest,
  TBodyPaymentGift,
  TGift,
  TResGiftPendingPayment,
  TResGiftPredict,
  TResPaymentGift,
  TSendGiftFree,
} from 'types';

const paymentGiftRequest = async (body: TBodyGiftRequest) => {
  return await axios.post('gifts/payment/request', body).then((response) => {
    return response.data;
  });
};

const paymentGift = async (
  body: TBodyPaymentGift,
): Promise<TResPaymentGift> => {
  return await axios.post('gifts/payment', body).then((response) => {
    return response.data;
  });
};

const getGiftPendingPayment = async (
  historyId: number,
): Promise<TResGiftPendingPayment> => {
  return await axios
    .get('gifts/pending', { params: { historyId } })
    .then((response) => {
      return response.data;
    });
};

const getGiftPredict = async (
  payload: TBodyGiftPredict,
): Promise<TResGiftPredict> => {
  return await axios
    .get(`gifts/predict`, {
      params: payload,
    })
    .then((response) => {
      return response.data;
    });
};

const getGiftList = async (channelId?: string): Promise<TGift[]> => {
  return await axios
    .get('gifts', { params: { channelId } })
    .then((response) => {
      return response.data;
    });
};

const sendGiftFree = async (body: TSendGiftFree): Promise<TResPaymentGift> => {
  return await axios.post('gifts/send-free', body).then((response) => {
    return response.data;
  });
};

export {
  paymentGiftRequest,
  paymentGift,
  getGiftPendingPayment,
  getGiftPredict,
  getGiftList,
  sendGiftFree,
};
